import { render, staticRenderFns } from "./layout-digital-human.vue?vue&type=template&id=63313ce5&scoped=true"
import script from "./layout-digital-human.vue?vue&type=script&lang=js"
export * from "./layout-digital-human.vue?vue&type=script&lang=js"
import style0 from "./layout-digital-human.vue?vue&type=style&index=0&id=63313ce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63313ce5",
  null
  
)

export default component.exports